import { Info } from "lucide-react";

export default function InfoModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center px-4" onClick={onClose}>
      <div
        data-testid="info-modal"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-black border-2 border-[#701A4F] rounded-2xl fade-up shadow-[0_0_34px_rgba(112,26,79,0.45)]"
      >
        <div className="px-6 py-5 border-b border-[#701A4F]/50 flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-full bg-[#701A4F] flex items-center justify-center shrink-0">
            <Info className="w-4 h-4 text-white" />
          </span>
          <h2 className="font-heading font-bold text-lg text-white uppercase tracking-wide">Probabilità Reale</h2>
        </div>
        <div className="px-6 py-5 space-y-3">
          <p className="text-sm text-slate-300 leading-relaxed">
            Le percentuali mostrate rappresentano la <span className="text-[#E3BC55] font-semibold">Probabilità Reale</span> di ciascun esito: le quote dei bookmaker vengono depurate dall'aggio (il margine del banco) e ponderate con lo storico degli scontri diretti tra le due squadre e il modello statistico Zero Signals.
          </p>
          <p className="text-sm text-slate-300 leading-relaxed">
            Più la percentuale è alta, più l'esito è statisticamente probabile. Le probabilità non costituiscono garanzia di risultato.
          </p>
        </div>
        <div className="px-6 py-5 border-t border-[#701A4F]/50">
          <button
            data-testid="info-modal-close-button"
            onClick={onClose}
            className="w-full py-3 rounded-xl bg-[#701A4F] text-white font-heading font-bold uppercase tracking-widest text-sm hover:bg-[#8B2364] transition-colors"
          >
            Ho Capito
          </button>
        </div>
      </div>
    </div>
  );
}
